import '@webauthjs/microsoft.office.webauth.abt';
import getUserConfiguration from 'owa-session-store/lib/actions/getUserConfiguration';
import isBusiness from 'owa-session-store/lib/utils/isBusiness';
import sleep from 'owa-sleep';
import { getGuid } from 'owa-guid';
import { signout } from 'owa-header/lib/actions/signout';
import { logUsage } from 'owa-analytics';
import { getAuthType } from './utils/SharedActivityBasedTimeoutAuthType';
import { getEnvironment } from './utils/SharedActivityBasedTimeoutEnvironment';
import { isFeatureEnabled } from 'owa-feature-flags';
import { getOrigin } from 'owa-url';

const SIGN_OUT_EVENT_KEY = 'abtSignOutEventForHost';
const ABT_INITIALIZED_EVENT_KEY = 'abtInitializeResult';
const OWA_WORKLOAD_KEY = 'OWA';
const RETRY_DELAY = 500;
const GUID: string = getGuid();

interface ExtendedWindow {
    LoadAbtPromptJs: Object;
}

declare var window: Window & ExtendedWindow;
var sharedABTInitAttempts: number = 0;

function processSharedABTEvent(event) {
    if (event.data && event.data !== '' && event.origin === getOrigin()) {
        var eventDetails = JSON.parse(event.data);
        if (eventDetails.eventId) {
            if (eventDetails.eventId === SIGN_OUT_EVENT_KEY) {
                logUsage('ActivityTimeout::Signout', {
                    sessionId: GUID,
                });
                signout(location);
            } else if (
                eventDetails.eventId === ABT_INITIALIZED_EVENT_KEY &&
                eventDetails.detail &&
                eventDetails.detail.initializeResult
            ) {
                if (eventDetails.detail.initializeResult === 'false') {
                    sleep(RETRY_DELAY).then(() => {
                        if (sharedABTInitAttempts < 3) {
                            logUsage('ActivityTimeout::RetryingIntialized', {
                                attempt: sharedABTInitAttempts,
                                sessionId: GUID,
                                failureMessage: eventDetails.detail.initializeMessage,
                            });
                            initializeSharedABT();
                        }
                    });
                } else {
                    logUsage('ActivityTimeout::Initialized', {
                        sessionId: GUID,
                    });
                }
            }
            /* TODO: capture and log when abt prompt event is triggered */
        }
    }
}

function registerSharedABTEvents(): void {
    window.addEventListener('message', processSharedABTEvent, false);
}

function initializeSharedABT(): void {
    let abtConfigOptions = {
        market: getUserConfiguration().SessionSettings.UserCulture,
        environment: getEnvironment(),
        userId: getUserConfiguration().SessionSettings.UserPuid,
        authType: getAuthType(),
        timeout: getUserConfiguration().PolicySettings.SharedActivityBasedTimeout,
        trackEvents: true,
        enableLogging: true,
        workloadName: OWA_WORKLOAD_KEY,
        tenantId: getUserConfiguration().SessionSettings.TenantGuid,
        sessionId: GUID,
        signinState: getUserConfiguration().PolicySettings.SignInState,
    };

    logUsage('ActivityTimeout::Initializing', {
        authType: abtConfigOptions.authType,
        timeout: abtConfigOptions.timeout,
        sessionId: GUID,
    });
    sharedABTInitAttempts++;
    window.AbtInteraction.AbtInitialize(abtConfigOptions);
}

function loadSharedABTPrompt(callback: Function): void {
    import('@webauthjs/microsoft.office.webauth.abt/js/AbtPrompt').then(_abtprompt => {
        callback?.();
    });
}

function attachSharedABTPromptCallback(): void {
    window.LoadAbtPromptJs = {
        Download: loadSharedABTPrompt,
    };
}

export function registerAndInitializeSharedABT(): void {
    if (
        isBusiness() &&
        isFeatureEnabled('auth-sharedActivityBasedTimeout') &&
        getUserConfiguration().PolicySettings.IsSharedActivityBasedTimeoutEnabled
    ) {
        attachSharedABTPromptCallback();
        registerSharedABTEvents();
        initializeSharedABT();
    }
}
